import React, { HTMLProps, SVGProps, useMemo } from "react";
import styles from "./index.module.scss";
import { parseInt } from "lodash-es";

interface Props extends HTMLProps<any> {
    size: number;
    progress: number | string;
    width?: number;
    fillColor?: string;
    children?: React.ReactNode;
}
const defaultProps: SVGProps<any> = {
    // strokeLinejoin: "round",
    // strokeLinecap: "round"
};
const Index = ({
    size,
    width = 8,
    fillColor = "#1593FF",
    progress,
    children,
    ...restProps
}: Props) => {
    const cirleProps = useMemo(() => {
        const obj: SVGProps<any> = {
            r: size / 2 - width / 2,
            cy: size / 2,
            cx: size / 2,
            strokeWidth: width
        };
        return obj;
    }, [size, width]);

    const dasharray = useMemo(() => {
        const R = size / 2 - width / 2;
        const Perimeter = Math.PI * 2 * R;
        const Progress =
            typeof progress === "string" ? parseInt(progress) : progress;
        const fillWidth = Perimeter * (Progress / 100);
        return `${fillWidth},${Perimeter - fillWidth + 10}`;
    }, [progress, width, size]);

    return (
        <div {...restProps}>
            <div className={styles.root} style={{ width: size, height: size }}>
                <div
                    className={styles.children}
                    style={{
                        width: size - width * 2,
                        height: size - width * 2
                    }}>
                    {children || <p className={styles.text}>{progress} %</p>}
                </div>
                <svg width={`${size}px`} height={`${size}px`}>
                    <circle
                        {...defaultProps}
                        {...cirleProps}
                        stroke="#EAEFF4"
                        fill="none"
                    />
                    <circle
                        {...defaultProps}
                        {...cirleProps}
                        className={styles.progress}
                        stroke={fillColor}
                        fill="none"
                        strokeDashoffset="0"
                        strokeDasharray={dasharray}
                    />
                </svg>
            </div>
        </div>
    );
};

export default Index;
